module.exports = __webpack_public_path__ + "static/media/aipass.3e79d55a.svg";